<template>
  <!-- 工作台 -->
  <el-container class="home-container">
    <el-header class="homeHeader">
      <div>
        <el-image :src="imgUrl"></el-image>
      </div>
      <div class="header_xiaoxi">
        <!-- <span @click="HrefClick" style="margin-right:1rem;">切换旧版</span> -->
        <span @click="HrefClick" style=""  style="margin-right:1rem;display:flex;font-size: 14px;">
            <p style="margin:0">新版</p>
            <p style="margin:0 3px;">/</p>
            <p style="color:#246DEB;margin:0">切换旧版</p>
        </span>
        <span>
          <img src="../assets/admin.png" alt srcset />
        </span>
        <span>{{name}}</span>
        <div>
            <i class="iconfont icon-xiaoxi"></i>
            <span >消息</span>
        </div>
        <span @click="outFn">退出</span>
      </div>
    </el-header>
    <el-container>
      <el-aside width="260px">
        <el-menu
          :collapse-transition="false"
          background-color="#2A354D"
          text-color="#fff"
          active-text-color="#fff"
          router
        >
          <template v-for="v in menu">
            <template v-if="v.childrens">
              <el-submenu :index="v.path">
                <template slot="title">
                  <img
                    :src="v.icon"
                    alt
                    srcset
                    style=" width:14px;height:14px; color: white;margin-right:5px"
                  />
                  <span slot="title">{{ v.title }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="vv in v.childrens"
                    :index="'/' + vv.path"
                    :key="vv.id"
                  >{{ vv.title }}</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="'/'+v.path">
                <img
                  :src="v.icon"
                  alt
                  srcset
                  style=" width:14px;height:14px; color: white;margin-right:5px"
                />
                <span slot="title">{{ v.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import {distributorTwoLogout,getDistributorTwoInfo} from '@/request/index.js'
export default {
  data() {
    return {
      imgUrl: require("../assets/logo.png"),
      // 景区菜单
      menu: [
        {
          id: 1,
          title: "上级信息",
          path: "dis",
          icon: require("../assets/hone.png"),
          children: [
            {
              id: 1 - 1,
              title: "上级列表",
              path: "dis"
            },
          ]
        },
        {
          id: 2,
          title: "产品管理",
          path: "product",
          icon: require("../assets/home2.png"),
          children: [
            {
              id: 2 - 1,
              title: "产品列表",
              path: "product"
            },
          ]
        },
        {
          id: 3,
          title: "财务报表",
          path: "finance",
          icon: require("../assets/home3.png"),
          children: [
            {
              id: 3 - 1,
              title: "订单查询",
              path: "secondorder"
            },
            {
              id: 3 - 2,
              title: "销售统计",
              path: "statistics"
            },
            // {
            //   id: 3 - 3,
            //   title: "分销退票",
            //   path: "refund"
            // },
          ]
        },
        {
          id: 4,
          title: "系统设置",
          path: "system",
          icon: require("../assets/home4.png"),
          children: [
            {
              id: 4 - 1,
              title: "分销商设置",
              path: "system"
            },
            {
              id: 4 - 2,
              title: "权限设置",
              path: "limits"
            },
            {
              id: 4 - 3,
              title: "密码设置",
              path: "resetting"
            },
          ]
        },
      ],
      name:''
    };
  },
  created(){
    if(this.$route.query.data){
      let datas = JSON.parse(this.$route.query.data)
      window.sessionStorage.setItem("menue", JSON.stringify(datas.permission));
      window.sessionStorage.setItem("Token", datas.token);
      window.sessionStorage.setItem('path','/secondlogin')
    }
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    getDistributorTwoInfo(data).then(res=>{
      if(res.data.status=='ok'){
        this.name = res.data.result.Name
      }
    })
    let Mmen = this.menu
    let menu = JSON.parse(window.sessionStorage.getItem('menue'))
    let arr = []
    Mmen.map(item=>{
      menu.map(itm=>{
        if(item.title==itm.title){
          arr.push(item)
        }
      })
    })
    arr.map(item=>{
      item.childrens = []
      menu.map(itm=>{
        if(item.title==itm.title){
          if(item.children){
            item.children.map(items=>{
              if(itm.son){
                itm.son.map(itms=>{
                  if(itms.title==items.title){
                    item.childrens.push(items)
                  }
                })
              }
            })
          }
        }
      })
    })
    this.menu = arr
    this.menu.map(item=>{
      if(item.childrens.length==0){
        delete item.childrens
      }
    })
  },
  methods: {
    HrefClick(){
      let href = 'http://home1.softykt.net/'
      window.open(href)
    },
    // 点击退出
    outFn() {
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      distributorTwoLogout(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('退出登录')
          window.sessionStorage.removeItem('Token');
          window.sessionStorage.removeItem('menue');
          this.$router.push("/secondlogin");
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
html{
  width: 50px;
}
.active {
  background-color: rgba(36, 109, 235, 0.4);
}
//设置了行高和字体大小、高度颜色
/deep/.el-menu-item {
  font-size: 14px;
  height: 52px;
  line-height: 52px;
  color: #666666;
  transition: none !important;
}
//子节点选中样式(前面只有一级，后面子级)
/deep/.el-menu-item.is-active,
.el-submenu .el-menu-item.is-active {
  background-color: rgba(36, 109, 235, 0.4) !important;
}
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #001529;
  color: white;
}
.homeHeader {
  display: flex;
  justify-content: space-between;
  > div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > span:nth-child(1) {
      .img {
        width: 12px;
        height: 12px;
      }
    }
    > span:nth-child(2) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */
      color: #ffffff;
      margin: 0 19px 0 8px;
    }
    > span:nth-child(3) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */

      color: #ffffff;
    }
  }
}

.el-aside {
  background-color: #2a354d;
}
.el-main {
  background: #e5e5e5;
}
.header_xiaoxi{
  display: flex;
  align-items: center;
  >div{
    span{
      margin-left: 0.8rem;
    }
    display: flex;
    align-items: center;
    margin-right: 1.9rem;
    margin-left: 0.8rem;
  }
}
</style>